var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h1',{directives:[{name:"band-title",rawName:"v-band-title"}],staticClass:"title-area",attrs:{"tabindex":"0"}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.sectionInfo.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }